export default "/images/vendor/flag-icons/flags/1x1/mv.svg?8cb05cc8693221f2eec147eb4f657c4f";